import React, { useEffect, useRef, useState } from "react";

// Counts up from 0 to `value` once on mount. Non-numeric values render as-is.
export function CountUp({ value, suffix = "", duration = 900, className, style }) {
  const numeric = typeof value === "number" && isFinite(value);
  const [display, setDisplay] = useState(numeric ? 0 : value);
  const rafRef = useRef();

  useEffect(() => {
    if (!numeric) {
      setDisplay(value);
      return;
    }
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      setDisplay(Math.round(eased * value));
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, numeric, duration]);

  return (
    <span className={className} style={style}>
      {display}
      {numeric ? suffix : ""}
    </span>
  );
}
